import React from 'react';
import { cn } from '../../lib/utils';
import { motion } from 'framer-motion';

export const FeatureCard = ({
  icon,
  title,
  description,
  className,
  iconClassName,
  delay = 0
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className={cn(
        'group relative overflow-hidden',
        'p-8 rounded-2xl',
        'bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900',
        'border border-gray-200 dark:border-gray-700',
        'hover:shadow-2xl hover:border-orange-300 dark:hover:border-orange-600',
        'transition-all duration-300',
        className
      )}
    >
      {/* Background gradient effect on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-500/0 to-orange-600/0 group-hover:from-orange-500/5 group-hover:to-orange-600/10 transition-all duration-300" />

      <div className="relative z-10">
        {/* Icon container */}
        <div className={cn(
          'w-16 h-16 mb-6 rounded-2xl',
          'bg-gradient-to-br from-orange-100 to-orange-50 dark:from-orange-900/30 dark:to-orange-800/20',
          'flex items-center justify-center',
          'group-hover:scale-110 transition-transform duration-300',
          iconClassName
        )}>
          <div className="text-orange-600 dark:text-orange-400">
            {icon}
          </div>
        </div>

        {/* Content */}
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-orange-600 dark:group-hover:text-orange-400 transition-colors">
          {title}
        </h3>
        <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
          {description}
        </p>
      </div>
    </motion.div>
  );
};

export default FeatureCard;
